angular.module( 'acme.view.application.membership.offerings.create.details.modals.autorenew', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.create.details.modals.autorenew.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsCreateDetailsModalsAutorenew = {
        name: 'application.membership.offerings.create.details.modals.autorenew',
        url: '/membership/offerings/create/details/modals/autorenew',
        views: {
          "main": {
            controller: 'MembershipOfferingsCreateDetailsModalsAutorenewController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/create/details/modals/autorenew/autorenew.tpl.html'
          }
        },
        data: {
          pageTitle: '      ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsCreateDetailsModalsAutorenew);
});
